import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { DossierResponseDto } from 'lib_api/lib/api/gen';

import UpdateEntiteRattachement from 'components/UpdateEntitesRattachements/UpdateEntiteRattachement';
import useInitialValues from 'components/UpdateEntitesRattachements/useInitialValues';
import { useApi } from 'hooks/ApiStoreContext';
import { useDossierContext } from 'hooks/dossiers/DossierContext';
import { useUserStore } from 'hooks/UserStoreContext';
import { extractNonnullDossierIdOrThrow } from 'utils/dossierUtils';
import { profileEnumMapping } from 'utils/enumData';

import buildSubmitFunction from './buildSubmitFunction';
import buildValidateFunction from './buildValidateFunction';

interface UpdateEntiteRattachementFOProps {
  closeModal: () => void;
}

function UpdateEntiteRattachementFO({
  closeModal,
}: UpdateEntiteRattachementFOProps): React.ReactElement {
  const user = useUserStore();
  const { homePath } = profileEnumMapping[user.profile];
  const navigate = useNavigate();
  const [{ result: dossier, setDossier }] = useDossierContext();
  const dossierId = extractNonnullDossierIdOrThrow(dossier);
  const controller = useApi().ForceOrdreControllerApi;
  const dossierController = useApi().DossierControllerApi;
  const initialValues = useInitialValues(dossier);

  const setDossierOrGoBack = (dossierReponse: DossierResponseDto) => {
    const responsibleIdCorrelationUniteFo =
      dossierReponse.computed?.uniteFODto?.idCorrelationParent ||
      dossierReponse.computed?.uniteFODto?.idCorrelation;
    if (responsibleIdCorrelationUniteFo !== user.idCorrelationUniteFO) {
      navigate(homePath);
    } else {
      setDossier(dossierReponse);
    }
  };

  const validateFunction = useCallback(
    buildValidateFunction(controller, dossierId),
    [controller, dossierId],
  );
  const submitFunction = useCallback(
    buildSubmitFunction(
      controller,
      dossierController,
      dossierId,
      setDossierOrGoBack,
      closeModal,
    ),
    [controller, dossierId],
  );

  return (
    <UpdateEntiteRattachement
      closeModal={closeModal}
      initialValues={initialValues}
      loading={!dossier}
      submitFunction={submitFunction}
      validateFunction={validateFunction}
    />
  );
}

export default UpdateEntiteRattachementFO;
